// extracted by mini-css-extract-plugin
export default {"facebook__btn":"Login_facebook__btn__XWXhx","google__btn":"Login_google__btn__vCfoH"};